import * as React from 'react';
import { ReactElement } from 'react';
import { SingleSelectOption } from './_single-select-option';
import './single-select-list.scss';

interface ISingleSelectListProps<TItem, TKeyName extends keyof TItem & string> {
    items: TItem[];
    value: TItem[TKeyName];
    onChange: (newValue: TItem[TKeyName]) => void;
    nameProperty: keyof TItem;
    disabled?: keyof TItem;
    keyProperty: TKeyName;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ActionButton?: () => ReactElement;
}

/**
 * component which can be used in order to render single-selection list in any container
 * @param props
 * @constructor
 */
const SingleSelectList = <TItem, TKeyName extends keyof TItem & string>(props: ISingleSelectListProps<TItem, TKeyName>) => {
    return (
        <div className='single-select-list'>
            {props.items.map((selectionItem, index) => {
                const selectionItemValue = selectionItem[props.keyProperty];
                const isSelected = selectionItemValue === props.value;
                const isDisabled = Boolean(selectionItem[props.disabled]) ?? false;
                const name = selectionItem[props.nameProperty].toString();

                return <SingleSelectOption
                    key={index}
                    isSelected={isSelected}
                    name={name}
                    disabled={isDisabled}
                    itemKey={selectionItemValue}
                    onClick={props.onChange}
                />;
            })}
        </div>
    );
};

export { SingleSelectList, ISingleSelectListProps };
